export class BulkRestoreResponseJobsInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "jobId",
            "baseName": "jobId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BulkRestoreResponseJobsInner.attributeTypeMap;
    }
    constructor() {
    }
}
